import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { filter, first, take, takeUntil } from 'rxjs';
import { StudyDicomInfo } from 'src/app/models/Study/study.model';
import { SaleHorse } from 'src/app/models/sales/sale-horse.model';
import { Sale } from 'src/app/models/sales/sales.model';
import { ViewerService } from 'src/app/services/viewer.service';
import { BaseUnsubscribeComponent } from 'src/app/shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { StudiesFacade } from 'src/app/shared-new/store/studies/studies.facade';
import { AuthService } from '../../services/auth.service';
import { RouteParamsService } from '../../services/route-param.service';
import { DateParserFormatter } from '../../utils/helper/date-parser-formatter';
import { StudyStatus } from 'src/app/shared-new/enums/study-status.enum';

@Component({
  selector: 'app-edit-clinical-study',
  templateUrl: './edit-clinical-study.component.html',
  styleUrls: ['./edit-clinical-study.component.scss'],
})
export class EditClinicalStudyComponent
  extends BaseUnsubscribeComponent
  implements OnInit
{
  horse: SaleHorse = null;
  sale: Sale = null;
  hipConfirmed = false;
  showTable = false;
  displayedColumns: string[] = [
    'entry',
    'hip',
    'accNo',
    'microchip',
    'type',    
    'horseName',
    'sire',
    'dam',
    //'dob',
    
    'consignor',
    'studyDate',
    'saleName',
    //'actions',
  ];

  dataSource: StudyDicomInfo[] = [];
  activeSaleHorseStudy$ = this.studyFacade.activeSaleHorseStudy$;
  activeStudyStatusId$ = this.studyFacade.activeStudyStatusId$;
  tabStatus$ = this.studyFacade.tabStatus$;
  tabStatus: any;
  StudyStatus = StudyStatus;
  studyFileRows$ = this.studyFacade.studyFileRows$;
  public lotOrHipText: string = '';

  public isSaleFeatureEnabled: boolean = true;
  @Input() sale_id: number;
  @Input() status_id: number;
  @Input() horse_id: number;
  @Output() closedClicked = new EventEmitter();

  get saleId(): number {
    let saleId = this.sale_id;
    if (this.route.snapshot.params['saleId']) {
      const parsed = parseInt(this.route.snapshot.params['saleId'], 10);
      saleId = Number.isFinite(parsed) ? parsed : 0;
    }
    return saleId;
  }


  get horseId(): number {
    let horseId = this.horse_id;
    if (this.route.snapshot.params['horseId']) {
      const parsed = parseInt(this.route.snapshot.params['horseId'], 10);
      horseId = Number.isFinite(parsed) ? parsed : 0;
    }
    return horseId;
  }

  get studyId(): number {
    let studyId = 0;
    if (this.route.snapshot.params['studyId']) {
      const parsed = parseInt(this.route.snapshot.params['studyId'], 10);
      studyId = Number.isFinite(parsed) ? parsed : 0;
    }
    return studyId;
  }

  constructor(
    public readonly authService: AuthService,
    private route: ActivatedRoute,
    private studyFacade: StudiesFacade,
    private viewerService: ViewerService,
    private dateParserFormatter: DateParserFormatter,
    private routeParamsService: RouteParamsService
  ) {
    super();
    this.isSaleFeatureEnabled =
      this.authService.GlobalMemberAccessData.isSaleFeatureEnabled;
    // TODO: I think we need a new study viewer if Sales Company role isn't required and Sale Feature is disabled.
  }

  ngOnInit(): void {
    if (this.authService)
    this.routeParamsService.updateParam({
      saleId: this.saleId,
      horseId: this.horseId,
      statusId: this.status_id,
    });
    this.studyFacade.resetData();
    this.studyFacade.loadMediaGroups();
    this.studyFacade.loadStatuses();
    this.studyFacade.getSaleHorseStudies(this.saleId, this.horseId);

    this.activeSaleHorseStudy$
      .pipe(
        takeUntil(this.unsubscribe$)
      )
      .subscribe((study) => {
        if (study) {
          this.sale = study.sale;
          this.lotOrHipText = study?.sale?.lotOrHipText ?? "HIP";
          this.horse = study.saleHorse;
        }
      });

    this.studyFileRows$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((horses) => {
        this.dataSource = horses;
      });

   

    this.tabStatus$
      .pipe(
        first((s) => !!s?.loaded),
        take(1)
      )
      .subscribe((status) => {
        if (this.status_id == StudyStatus.Approved) { status.landOnApprovedTab = true; }
        this.tabStatus = status;
        this.hipConfirmed = true;
      });
  }

  confirmHip(): void {
    this.hipConfirmed = true;
    //this.showTable = false;
  }

  viewStudy(studyInstanceUID: string, horseName: string): void {
    this.activeSaleHorseStudy$.pipe(take(1)).subscribe((study) => {
      this.viewerService.openDicomViewerForStudy(study, '');
    });
  }
  getDateFormation(): String {
    if (this.sale) {
      const formation = this.dateParserFormatter.getDateFormatForSale(
        this.sale,
        true
      );
      return formation;
    }

    return '';
  }

  toggleTable(): void {
    this.showTable = !this.showTable;
  }

  closeModal(): void {
    this.closedClicked.emit();
  }
  onChangeTab(selectedTab: any) {
    if (selectedTab == "APPROVED") {
     // this.showTable = false;
    } else {
      //this.showTable = true;
    }
  }
}
